import { ArrowBack } from '@mui/icons-material'
import { IconButton, Tooltip, useTheme } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import { EClientPath } from '~/models/api'
import rem from '~/utils/ui'

export default function OfuManageBackButton() {
  const theme = useTheme()
  const navigate = useNavigate()
  const handleNavigateToCampaigns = () => {
    navigate(EClientPath.campaignList)
  }
  return (
    <Tooltip title="View all campaigns">
      <IconButton
        onClick={handleNavigateToCampaigns}
        aria-label="View all campaigns"
        size="small"
        color="inherit"
        sx={{
          width: rem(32),
          height: rem(32),
          border: `${rem(1)} solid ${theme.palette.secondaryButtonFont}`,
          borderRadius: rem(8),
          '&:hover': {
            borderColor: theme.palette.tertiary1,
            color: theme.palette.tertiary1,
            backgroundColor: 'transparent',
          },
          '&:disabled': {
            borderColor: theme.palette.tertiary5,
            color: theme.palette.tertiary5,
          },
        }}
      >
        <ArrowBack fontSize="small" />
      </IconButton>
    </Tooltip>
  )
}
